import React, { useState } from "react";
import Axios from "axios";
import { Modal, Input, message } from "antd";
import { useDispatch } from "react-redux";
import { getOrder } from "../../../../../redux/Actions/orderAction";

const BlacklistIcon = ({ blacklisted }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1 7.66667C1 3.98467 3.98467 1 7.66667 1C11.3487 1 14.3333 3.98467 14.3333 7.66667C14.3333 11.3487 11.3487 14.3333 7.66667 14.3333C3.98467 14.3333 1 11.3487 1 7.66667ZM7.66667 2.33333C6.25218 2.33333 4.89562 2.89524 3.89543 3.89543C2.89524 4.89562 2.33333 6.25218 2.33333 7.66667C2.33333 9.08115 2.89524 10.4377 3.89543 11.4379C4.89562 12.4381 6.25218 13 7.66667 13C9.08115 13 10.4377 12.4381 11.4379 11.4379C12.4381 10.4377 13 9.08115 13 7.66667C13 6.25218 12.4381 4.89562 11.4379 3.89543C10.4377 2.89524 9.08115 2.33333 7.66667 2.33333Z" fill={blacklisted ? "#dc3545" : "#6C6C6C"} />
    {blacklisted ? (
      <path fillRule="evenodd" clipRule="evenodd" d="M4.33341 6.99996C4.1566 6.99996 3.98703 7.0702 3.86201 7.19522C3.73699 7.32025 3.66675 7.48981 3.66675 7.66663C3.66675 7.84344 3.73699 8.01301 3.86201 8.13803C3.98703 8.26305 4.1566 8.33329 4.33341 8.33329H11.0001C11.1769 8.33329 11.3465 8.26305 11.4715 8.13803C11.5965 8.01301 11.6667 7.84344 11.6667 7.66663C11.6667 7.48981 11.5965 7.32025 11.4715 7.19522C11.3465 7.0702 11.1769 6.99996 11.0001 6.99996H4.33341Z" fill="#dc3545" />
    ) : (
      <path fillRule="evenodd" clipRule="evenodd" d="M8.33342 4.33329C8.33342 4.15648 8.26318 3.98691 8.13815 3.86189C8.01313 3.73686 7.84356 3.66663 7.66675 3.66663C7.48994 3.66663 7.32037 3.73686 7.19534 3.86189C7.07032 3.98691 7.00008 4.15648 7.00008 4.33329V6.99996H4.33341C4.1566 6.99996 3.98703 7.0702 3.86201 7.19522C3.73699 7.32025 3.66675 7.48981 3.66675 7.66663C3.66675 7.84344 3.73699 8.01301 3.86201 8.13803C3.98703 8.26305 4.1566 8.33329 4.33341 8.33329H7.00008V11C7.00008 11.1768 7.07032 11.3463 7.19534 11.4714C7.32037 11.5964 7.48994 11.6666 7.66675 11.6666C7.84356 11.6666 8.01313 11.5964 8.13815 11.4714C8.26318 11.3463 8.33342 11.1768 8.33342 11V8.33329H11.0001C11.1769 8.33329 11.3465 8.26305 11.4715 8.13803C11.5965 8.01301 11.6667 7.84344 11.6667 7.66663C11.6667 7.48981 11.5965 7.32025 11.4715 7.19522C11.3465 7.0702 11.1769 6.99996 11.0001 6.99996H8.33342V4.33329Z" fill="#6C6C6C" />
    )}
  </svg>
);

const BlacklistButton = ({
  customerId,
  orderId,
  blacklisted,
  blacklistReason,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [reason, setReason] = useState(blacklistReason || "");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (!visible) {
      setReason(blacklistReason || "");
    }
  }, [blacklistReason, visible]);

  const resetModal = () => {
    setVisible(false);
    setReason(blacklistReason || "");
  };

  const handleOk = async () => {
    if (!customerId) {
      return message.error("Customer not found");
    }

    setLoading(true);

    try {
      if (blacklisted) {
        await Axios.post(`/api/v1/customers/${customerId}/remove_from_blacklist`);
        message.success("Customer removed from blacklist");
      } else {
        await Axios.post(`/api/v1/customers/${customerId}/add_to_blacklist`, {
          reason
        });
        message.success("Customer added to blacklist");
      }

      resetModal();
      if (orderId) {
        dispatch(getOrder(orderId));
      }
      if (onSuccess) {
        onSuccess();
      }
    } catch (_error) {
      message.error("Failed to update blacklist status");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    resetModal();
  };

  return (
    <>
      <button
        className="btn btn-sm d-flex justify-content-center align-items-center blacklist-btn"
        style={{
          minWidth: "50px",
          maxWidth: "150px",
          height: "30px",
          color: blacklisted ? "#dc3545" : "#6C6C6C",
          borderColor: blacklisted ? "#dc3545" : "#6C6C6C",
        }}
        onClick={() => setVisible(true)}
      >
        <BlacklistIcon blacklisted={blacklisted} />
        <span className="ml-2">
          {blacklisted ? "Blacklist" : "Blacklist"}
        </span>
      </button>
      <Modal
        title={
          blacklisted
            ? "Remove this customer from blacklist?"
            : "Are you sure you want to blacklist this customer?"
        }
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
        okText={blacklisted ? "Remove" : "Confirm"}
        cancelText="Cancel"
      >
        {blacklisted ? (
          <div>
            {blacklistReason || "This customer is currently blacklisted."}
          </div>
        ) : (
          <Input
            placeholder="Give a reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        )}
      </Modal>
    </>
  );
};

export default BlacklistButton;
